import React, { Component } from "react";
import { View, Image, TouchableOpacity, ScrollView } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles} from '../theme/styles'
import TextView from "../components/TextView";
import { revenueRequest } from "../utils/api";
import { hp, wp } from "../utils/responsive";
import Waiting from "../components/Waiting";
import { persianNumber, priceString, getMonth } from "../utils/utils";
import { greenLightColor, greenDarkColor, blueLightColor, blueDarkColor } from "../theme/colors";
import LinearGradient from 'react-native-linear-gradient';
import DialogList from "../components/DialogList";

export default class RevenueScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: null,
            waiting: true,
            monthModal: false,
            months: [
                { number: 1, name: 'فروردین' },
                { number: 2, name: 'اردیبهشت' },
                { number: 3, name: 'خرداد' },
                { number: 4, name: 'تیر' },
                { number: 5, name: 'مرداد' },
                { number: 6, name: 'شهریور' },
                { number: 7, name: 'مهر' },
                { number: 8, name: 'آبان' },
                { number: 9, name: 'آذر' },
                { number: 10, name: 'دی' },
                { number: 11, name: 'بهمن' },
                { number: 12, name: 'اسفند' }]
        }
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>میزان کارکرد</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            {this.state.data != null ? <ScrollView>
                <View style={[{ width: wp(90), margin: wp(5), borderRadius: 15, backgroundColor: 'white' }, appStyles.shadow]}>
                    <View style={[appStyles.center, { height: hp(8) }]}>
                        <TextView style={{ color: '#919191' }}>درآمد امروز     (<TextView style={{ color: '#919191', fontSize: 12 }}>{this.state.data.today_date}</TextView>)</TextView>
                    </View>
                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenLightColor, greenDarkColor]}
                        style={[{ width: wp(90), height: hp(8), borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }, appStyles.center]}>
                        <TextView style={{ color: 'white', fontSize: 18 }}>{priceString(this.state.data.today_revenue)}    <TextView style={{ color: 'white', fontSize: 12 }}> (تومان)</TextView></TextView>
                    </LinearGradient>

                </View>
                <View style={appStyles.rowAround}>
                    <View style={[{ width: wp(42), marginLeft: wp(5), borderRadius: 15, backgroundColor: 'white' }, appStyles.shadow]}>
                        <View style={[appStyles.center, { height: hp(12) }]}>
                            <TextView style={{ color: '#919191', margin: 10 }}>درآمد ماهانه</TextView>
                            <TouchableOpacity style={[{ flexDirection: 'row', borderWidth: 1, height: 24, borderRadius: 12, borderColor: '#C6C6C6' }, appStyles.center]} onPress={() => {
                                this.setState({
                                    monthModal: true
                                })
                            }}>
                                <Image source={icons['dropdown']} style={{ tintColor: '#C6C6C6', width: 15, height: 15, resizeMode: 'contain', marginLeft: 5, marginRight: 10 }} />
                                <TextView style={{ color: '#919191', fontSize: 12, marginRight: 10, marginLeft: 10 }}>{getMonth(this.state.data.month_number)}</TextView>
                            </TouchableOpacity>
                        </View>
                        <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenLightColor, greenDarkColor]}
                            style={[{ width: wp(42), height: hp(8), borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }, appStyles.center]}>
                            <TextView style={{ color: 'white' }}>{priceString(this.state.data.month_revenue)}  <TextView style={{ color: 'white', fontSize: 12 }}> (تومان)</TextView></TextView>
                        </LinearGradient>
                    </View>
                    <View style={[{ width: wp(42), marginLeft: wp(5), marginRight: wp(5), borderRadius: 15, backgroundColor: 'white' }, appStyles.shadow]}>
                        <View style={[appStyles.center, { height: hp(12) }]}>
                            <TextView style={{ color: '#919191', margin: 10 }}>درآمد هفتگی</TextView>
                            <TextView style={{ color: '#919191', fontSize: 12 }}>({persianNumber(this.state.data.week_date_of)}) تا ({persianNumber(this.state.data.week_date_to)})</TextView>
                        </View>
                        <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenLightColor, greenDarkColor]}
                            style={[{ width: wp(42), height: hp(8), borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }, appStyles.center]}>
                            <TextView style={{ color: 'white' }}>{priceString(this.state.data.week_revenue)}  <TextView style={{ color: 'white', fontSize: 12 }}> (تومان)</TextView></TextView>
                        </LinearGradient>
                    </View>

                </View>
                <View style={[appStyles.rowAround, { marginTop: wp(5) }]}>
                    <View style={[{ width: wp(42), height: hp(20), alignItems: 'center', justifyContent: 'center', marginLeft: wp(5), borderRadius: 15, backgroundColor: 'white' }, appStyles.shadow]}>
                        <TextView style={{ color: '#919191' }}>رتبه درآمدی</TextView>
                        <View style={{ height: 2, width: wp(39), backgroundColor: '#FBFBFB', marginTop: wp(5), marginBottom: wp(5) }} />
                        <TextView isbold={true} style={{ color: '#3CE685', fontSize: 20 }}>{persianNumber(this.state.data.rank_revenue)}</TextView>
                    </View>
                    <View style={[{ width: wp(42), height: hp(20), alignItems: 'center', justifyContent: 'center', marginLeft: wp(5), marginRight: wp(5), borderRadius: 15, backgroundColor: 'white' }, appStyles.shadow]}>
                        <TextView style={{ color: '#919191' }}>رتبه کارکردی</TextView>
                        <View style={{ height: 2, width: wp(39), backgroundColor: '#FBFBFB', marginTop: wp(5), marginBottom: wp(5) }} />
                        <TextView isbold={true} style={{ color: '#3CE685', fontSize: 20 }}>{persianNumber(this.state.data.rank_jobs)}</TextView>
                    </View>
                </View>
                <View style={[{ width: wp(90), margin: wp(5), borderRadius: 15, backgroundColor: 'white' }, appStyles.shadow]}>
                    <View style={[appStyles.center, { height: hp(8) }]}>
                        <TextView style={{ color: '#919191' }}>میزان کل درآمد شما از آد</TextView>
                    </View>
                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[blueLightColor, blueDarkColor]}
                        style={[{ width: wp(90), height: hp(8), borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }, appStyles.center]}>
                        <TextView style={{ color: 'white', fontSize: 18 }}>{priceString(this.state.data.all_revenue)}   <TextView style={{ color: 'white', fontSize: 12 }}> (تومان)</TextView></TextView>
                    </LinearGradient>

                </View>
            </ScrollView> : null}
            <DialogList
                show={this.state.monthModal}
                title='انتخاب ماه'
                field='name'
                data={this.state.months}
                onSelect={(item, index) => {
                    this.setState({
                        monthModal: false,
                    }, () => {
                        this.getData(item.number);
                    })

                }}
                onCancel={() => {
                    this.setState({
                        monthModal: false
                    })
                }} />
            <Waiting waiting={this.state.waiting} />
        </View>)
    }
    componentWillMount() {
        this.getData('')
    }
    getData(month) {
        this.setState({
            waiting: true
        })
        revenueRequest(month, (isConnect, response) => {
            this.setState({
                waiting: false,
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    data: response.data
                })
            }
        })
    }

}
